var _rect, _path, _path2, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect0, _rect1, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22, _rect23, _rect24, _rect25, _rect26, _rect27, _rect28, _rect29, _rect30, _rect31, _rect32, _rect33, _rect34, _rect35, _rect36, _rect37, _rect38, _rect39, _rect40, _rect41, _rect42, _rect43, _rect44, _rect45, _rect46, _rect47, _rect48, _rect49, _rect50, _rect51, _rect52, _rect53, _rect54, _rect55, _rect56, _rect57, _rect58, _rect59, _rect60, _rect61, _rect62, _rect63, _rect64, _rect65, _rect66, _rect67, _rect68, _rect69, _rect70, _rect71, _rect72, _rect73, _rect74, _rect75, _rect76, _rect77, _rect78, _rect79, _rect80, _rect81, _rect82, _rect83, _rect84, _rect85, _rect86, _rect87, _rect88, _rect89, _rect90, _rect91, _rect92, _rect93, _rect94, _rect95, _rect96, _rect97, _rect98, _rect99, _rect100, _rect101, _rect102, _rect103, _rect104, _rect105, _path3, _path4, _path5, _path6, _line, _line2, _line3, _line4, _line5, _line6, _line7, _line8, _line9, _line0, _line1, _line10, _line11, _line12, _line13, _line14, _line15, _line16, _line17, _line18, _line19, _line20, _line21, _line22, _line23, _line24, _line25, _line26, _line27, _g, _path7, _path8, _rect106, _rect107, _rect108, _rect109, _rect110, _rect111, _rect112, _rect113, _rect114, _rect115, _rect116, _rect117, _rect118, _rect119, _rect120, _rect121, _path9, _path0, _path1, _rect122, _rect123, _rect124, _rect125, _rect126, _rect127, _rect128, _rect129, _rect130, _rect131, _rect132, _rect133, _rect134, _rect135, _rect136, _rect137, _rect138, _rect139, _rect140, _rect141, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _circle, _path52, _path53, _rect142, _rect143, _rect144, _rect145, _rect146, _rect147, _rect148, _rect149, _rect150, _rect151, _rect152, _rect153, _rect154, _rect155, _rect156, _rect157, _rect158, _rect159, _rect160, _rect161, _rect162, _rect163, _rect164, _rect165, _rect166, _rect167, _rect168, _rect169, _rect170, _rect171, _rect172, _rect173, _rect174, _rect175, _rect176, _rect177, _rect178, _rect179, _rect180, _rect181, _rect182, _rect183, _rect184, _rect185, _rect186, _rect187, _rect188, _rect189, _rect190, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNightBuildings(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 586,
    height: 502,
    viewBox: "0 0 586 502",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 493,
    width: 586,
    height: 9,
    fill: "#C4C4C4"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M377 493V219.363H389.572V163.973H396.11V136.041H403.15V127.52H409.185V72.1294L421.254 57.9268L432.821 72.1294V127.52H439.358V136.041H446.902V163.973H453.439V219.363H464V493H434.832H406.671H377Z",
    fill: "#47433F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M406.671 219.363V493M406.671 219.363H389.572M406.671 219.363V163.973H396.11M406.671 493H377V219.363H389.572M406.671 493H434.832M389.572 219.363V163.973H396.11M396.11 163.973V136.041H403.15M434.832 493V219.363M434.832 493H464V219.363H453.439M434.832 219.363V163.973H446.902M434.832 219.363H453.439M453.439 219.363V163.973H446.902M446.902 163.973V136.041H439.358M439.358 136.041V127.52H432.821M439.358 136.041H403.15M403.15 136.041V127.52H409.185M409.185 127.52V72.1294M409.185 127.52H432.821M409.185 72.1294H432.821M409.185 72.1294L421.254 57.9268M432.821 72.1294V127.52M432.821 72.1294L421.254 57.9268M421.254 57.9268V21",
    stroke: "black"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 401.5,
    y: 144.5,
    width: 6,
    height: 10,
    fill: "#FFF31E",
    stroke: "black"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 412.5,
    y: 161.5,
    width: 6,
    height: 10,
    fill: "#FFF31E",
    stroke: "black"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 423.5,
    y: 161.5,
    width: 6,
    height: 10,
    fill: "#FFF31E",
    stroke: "black"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 423.5,
    y: 178.5,
    width: 6,
    height: 10,
    fill: "#FFF31E",
    stroke: "black"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 423.5,
    y: 195.5,
    width: 6,
    height: 10,
    fill: "#FFF31E",
    stroke: "black"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 423.5,
    y: 212.5,
    width: 6,
    height: 10,
    fill: "#FFF31E",
    stroke: "black"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 423.5,
    y: 229.5,
    width: 6,
    height: 10,
    fill: "#FFF31E",
    stroke: "black"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 423.5,
    y: 246.5,
    width: 6,
    height: 10,
    fill: "#FFF31E",
    stroke: "black"
  })), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    x: 423.5,
    y: 263.5,
    width: 6,
    height: 10,
    fill: "#FFF31E",
    stroke: "black"
  })), _rect1 || (_rect1 = /*#__PURE__*/React.createElement("rect", {
    x: 423.5,
    y: 280.5,
    width: 6,
    height: 10,
    fill: "#FFF31E",
    stroke: "black"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 423.5,
    y: 297.5,
    width: 6,
    height: 10,
    fill: "#FFF31E",
    stroke: "black"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 423.5,
    y: 314.5,
    width: 6,
    height: 10,
    fill: "#FFF31E",
    stroke: "black"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 423.5,
    y: 331.5,
    width: 6,
    height: 10,
    fill: "#FFF31E",
    stroke: "black"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 423.5,
    y: 348.5,
    width: 6,
    height: 10,
    fill: "#FFF31E",
    stroke: "black"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 423.5,
    y: 365.5,
    width: 6,
    height: 10,
    fill: "#FFF31E",
    stroke: "black"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 423.5,
    y: 382.5,
    width: 6,
    height: 10,
    fill: "#FFF31E",
    stroke: "black"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 423.5,
    y: 399.5,
    width: 6,
    height: 10,
    fill: "#FFF31E",
    stroke: "black"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 423.5,
    y: 416.5,
    width: 6,
    height: 10,
    fill: "#FFF31E",
    stroke: "black"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 423.5,
    y: 433.5,
    width: 6,
    height: 10,
    fill: "#FFF31E",
    stroke: "black"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 423.5,
    y: 450.5,
    width: 6,
    height: 10,
    fill: "#FFF31E",
    stroke: "black"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 423.5,
    y: 467.5,
    width: 6,
    height: 10,
    fill: "#FFF31E",
    stroke: "black"
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 412.5,
    y: 467.5,
    width: 6,
    height: 10,
    fill: "#FFF31E",
    stroke: "black"
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 412.5,
    y: 450.5,
    width: 6,
    height: 10,
    fill: "#FFF31E",
    stroke: "black"
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    x: 412.5,
    y: 433.5,
    width: 6,
    height: 10,
    fill: "#FFF31E",
    stroke: "black"
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    x: 412.5,
    y: 416.5,
    width: 6,
    height: 10,
    fill: "#FFF31E",
    stroke: "black"
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    x: 412.5,
    y: 399.5,
    width: 6,
    height: 10,
    fill: "#FFF31E",
    stroke: "black"
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    x: 412.5,
    y: 382.5,
    width: 6,
    height: 10,
    fill: "#FFF31E",
    stroke: "black"
  })), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    x: 412.5,
    y: 365.5,
    width: 6,
    height: 10,
    fill: "#FFF31E",
    stroke: "black"
  })), _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    x: 412.5,
    y: 348.5,
    width: 6,
    height: 10,
    fill: "#FFF31E",
    stroke: "black"
  })), _rect29 || (_rect29 = /*#__PURE__*/React.createElement("rect", {
    x: 412.5,
    y: 331.5,
    width: 6,
    height: 10,
    fill: "#FFF31E",
    stroke: "black"
  })), _rect30 || (_rect30 = /*#__PURE__*/React.createElement("rect", {
    x: 412.5,
    y: 314.5,
    width: 6,
    height: 10,
    fill: "#FFF31E",
    stroke: "black"
  })), _rect31 || (_rect31 = /*#__PURE__*/React.createElement("rect", {
    x: 412.5,
    y: 297.5,
    width: 6,
    height: 10,
    fill: "#FFF31E",
    stroke: "black"
  })), _rect32 || (_rect32 = /*#__PURE__*/React.createElement("rect", {
    x: 412.5,
    y: 280.5,
    width: 6,
    height: 10,
    fill: "#FFF31E",
    stroke: "black"
  })), _rect33 || (_rect33 = /*#__PURE__*/React.createElement("rect", {
    x: 412.5,
    y: 263.5,
    width: 6,
    height: 10,
    fill: "#FFF31E",
    stroke: "black"
  })), _rect34 || (_rect34 = /*#__PURE__*/React.createElement("rect", {
    x: 412.5,
    y: 246.5,
    width: 6,
    height: 10,
    fill: "#FFF31E",
    stroke: "black"
  })), _rect35 || (_rect35 = /*#__PURE__*/React.createElement("rect", {
    x: 412.5,
    y: 229.5,
    width: 6,
    height: 10,
    fill: "#FFF31E",
    stroke: "black"
  })), _rect36 || (_rect36 = /*#__PURE__*/React.createElement("rect", {
    x: 412.5,
    y: 212.5,
    width: 6,
    height: 10,
    fill: "#FFF31E",
    stroke: "black"
  })), _rect37 || (_rect37 = /*#__PURE__*/React.createElement("rect", {
    x: 412.5,
    y: 195.5,
    width: 6,
    height: 10,
    fill: "#FFF31E",
    stroke: "black"
  })), _rect38 || (_rect38 = /*#__PURE__*/React.createElement("rect", {
    x: 412.5,
    y: 178.5,
    width: 6,
    height: 10,
    fill: "#FFF31E",
    stroke: "black"
  })), _rect39 || (_rect39 = /*#__PURE__*/React.createElement("rect", {
    x: 412.5,
    y: 144.5,
    width: 6,
    height: 10,
    fill: "#FFF31E",
    stroke: "black"
  })), _rect40 || (_rect40 = /*#__PURE__*/React.createElement("rect", {
    x: 423.5,
    y: 144.5,
    width: 6,
    height: 10,
    fill: "#FFF31E",
    stroke: "black"
  })), _rect41 || (_rect41 = /*#__PURE__*/React.createElement("rect", {
    x: 434.5,
    y: 144.5,
    width: 6,
    height: 10,
    fill: "#FFF31E",
    stroke: "black"
  })), _rect42 || (_rect42 = /*#__PURE__*/React.createElement("rect", {
    x: 441.5,
    y: 178.5,
    width: 6,
    height: 10,
    fill: "#EEEA27",
    stroke: "black"
  })), _rect43 || (_rect43 = /*#__PURE__*/React.createElement("rect", {
    x: 394.5,
    y: 178.5,
    width: 6,
    height: 10,
    fill: "#EEEA27",
    stroke: "black"
  })), _rect44 || (_rect44 = /*#__PURE__*/React.createElement("rect", {
    x: 394.5,
    y: 195.5,
    width: 6,
    height: 10,
    fill: "#EEEA27",
    stroke: "black"
  })), _rect45 || (_rect45 = /*#__PURE__*/React.createElement("rect", {
    x: 394.5,
    y: 229.5,
    width: 6,
    height: 10,
    fill: "#EEEA27",
    stroke: "black"
  })), _rect46 || (_rect46 = /*#__PURE__*/React.createElement("rect", {
    x: 258.5,
    y: 237.5,
    width: 6,
    height: 10,
    fill: "#EEEA27",
    stroke: "black"
  })), _rect47 || (_rect47 = /*#__PURE__*/React.createElement("rect", {
    x: 441.5,
    y: 229.5,
    width: 6,
    height: 10,
    fill: "#EEEA27",
    stroke: "black"
  })), _rect48 || (_rect48 = /*#__PURE__*/React.createElement("rect", {
    x: 441.5,
    y: 246.5,
    width: 6,
    height: 10,
    fill: "#EEEA27",
    stroke: "black"
  })), _rect49 || (_rect49 = /*#__PURE__*/React.createElement("rect", {
    x: 441.5,
    y: 263.5,
    width: 6,
    height: 10,
    fill: "#EEEA27",
    stroke: "black"
  })), _rect50 || (_rect50 = /*#__PURE__*/React.createElement("rect", {
    x: 441.5,
    y: 280.5,
    width: 6,
    height: 10,
    fill: "#EEEA27",
    stroke: "black"
  })), _rect51 || (_rect51 = /*#__PURE__*/React.createElement("rect", {
    x: 441.5,
    y: 297.5,
    width: 6,
    height: 10,
    fill: "#EEEA27",
    stroke: "black"
  })), _rect52 || (_rect52 = /*#__PURE__*/React.createElement("rect", {
    x: 441.5,
    y: 314.5,
    width: 6,
    height: 10,
    fill: "#EEEA27",
    stroke: "black"
  })), _rect53 || (_rect53 = /*#__PURE__*/React.createElement("rect", {
    x: 441.5,
    y: 331.5,
    width: 6,
    height: 10,
    fill: "#EEEA27",
    stroke: "black"
  })), _rect54 || (_rect54 = /*#__PURE__*/React.createElement("rect", {
    x: 441.5,
    y: 348.5,
    width: 6,
    height: 10,
    fill: "#EEEA27",
    stroke: "black"
  })), _rect55 || (_rect55 = /*#__PURE__*/React.createElement("rect", {
    x: 441.5,
    y: 365.5,
    width: 6,
    height: 10,
    fill: "#EEEA27",
    stroke: "black"
  })), _rect56 || (_rect56 = /*#__PURE__*/React.createElement("rect", {
    x: 441.5,
    y: 382.5,
    width: 6,
    height: 10,
    fill: "#EEEA27",
    stroke: "black"
  })), _rect57 || (_rect57 = /*#__PURE__*/React.createElement("rect", {
    x: 441.5,
    y: 399.5,
    width: 6,
    height: 10,
    fill: "#EEEA27",
    stroke: "black"
  })), _rect58 || (_rect58 = /*#__PURE__*/React.createElement("rect", {
    x: 441.5,
    y: 416.5,
    width: 6,
    height: 10,
    fill: "#EEEA27",
    stroke: "black"
  })), _rect59 || (_rect59 = /*#__PURE__*/React.createElement("rect", {
    x: 441.5,
    y: 433.5,
    width: 6,
    height: 10,
    fill: "#EEEA27",
    stroke: "black"
  })), _rect60 || (_rect60 = /*#__PURE__*/React.createElement("rect", {
    x: 441.5,
    y: 450.5,
    width: 6,
    height: 10,
    fill: "#EEEA27",
    stroke: "black"
  })), _rect61 || (_rect61 = /*#__PURE__*/React.createElement("rect", {
    x: 441.5,
    y: 467.5,
    width: 6,
    height: 10,
    fill: "#EEEA27",
    stroke: "black"
  })), _rect62 || (_rect62 = /*#__PURE__*/React.createElement("rect", {
    x: 452.5,
    y: 229.5,
    width: 6,
    height: 10,
    fill: "#EEEA27",
    stroke: "black"
  })), _rect63 || (_rect63 = /*#__PURE__*/React.createElement("rect", {
    x: 452.5,
    y: 246.5,
    width: 6,
    height: 10,
    fill: "#EEEA27",
    stroke: "black"
  })), _rect64 || (_rect64 = /*#__PURE__*/React.createElement("rect", {
    x: 452.5,
    y: 263.5,
    width: 6,
    height: 10,
    fill: "#EEEA27",
    stroke: "black"
  })), _rect65 || (_rect65 = /*#__PURE__*/React.createElement("rect", {
    x: 452.5,
    y: 280.5,
    width: 6,
    height: 10,
    fill: "#EEEA27",
    stroke: "black"
  })), _rect66 || (_rect66 = /*#__PURE__*/React.createElement("rect", {
    x: 452.5,
    y: 297.5,
    width: 6,
    height: 10,
    fill: "#EEEA27",
    stroke: "black"
  })), _rect67 || (_rect67 = /*#__PURE__*/React.createElement("rect", {
    x: 452.5,
    y: 314.5,
    width: 6,
    height: 10,
    fill: "#EEEA27",
    stroke: "black"
  })), _rect68 || (_rect68 = /*#__PURE__*/React.createElement("rect", {
    x: 452.5,
    y: 331.5,
    width: 6,
    height: 10,
    fill: "#EEEA27",
    stroke: "black"
  })), _rect69 || (_rect69 = /*#__PURE__*/React.createElement("rect", {
    x: 452.5,
    y: 348.5,
    width: 6,
    height: 10,
    fill: "#EEEA27",
    stroke: "black"
  })), _rect70 || (_rect70 = /*#__PURE__*/React.createElement("rect", {
    x: 452.5,
    y: 365.5,
    width: 6,
    height: 10,
    fill: "#EEEA27",
    stroke: "black"
  })), _rect71 || (_rect71 = /*#__PURE__*/React.createElement("rect", {
    x: 452.5,
    y: 382.5,
    width: 6,
    height: 10,
    fill: "#EEEA27",
    stroke: "black"
  })), _rect72 || (_rect72 = /*#__PURE__*/React.createElement("rect", {
    x: 452.5,
    y: 399.5,
    width: 6,
    height: 10,
    fill: "#EEEA27",
    stroke: "black"
  })), _rect73 || (_rect73 = /*#__PURE__*/React.createElement("rect", {
    x: 452.5,
    y: 416.5,
    width: 6,
    height: 10,
    fill: "#EEEA27",
    stroke: "black"
  })), _rect74 || (_rect74 = /*#__PURE__*/React.createElement("rect", {
    x: 452.5,
    y: 433.5,
    width: 6,
    height: 10,
    fill: "#EEEA27",
    stroke: "black"
  })), _rect75 || (_rect75 = /*#__PURE__*/React.createElement("rect", {
    x: 452.5,
    y: 450.5,
    width: 6,
    height: 10,
    fill: "#EEEA27",
    stroke: "black"
  })), _rect76 || (_rect76 = /*#__PURE__*/React.createElement("rect", {
    x: 452.5,
    y: 467.5,
    width: 6,
    height: 10,
    fill: "#EEEA27",
    stroke: "black"
  })), _rect77 || (_rect77 = /*#__PURE__*/React.createElement("rect", {
    x: 394.5,
    y: 246.5,
    width: 6,
    height: 10,
    fill: "#EEEA27",
    stroke: "black"
  })), _rect78 || (_rect78 = /*#__PURE__*/React.createElement("rect", {
    x: 394.5,
    y: 263.5,
    width: 6,
    height: 10,
    fill: "#EEEA27",
    stroke: "black"
  })), _rect79 || (_rect79 = /*#__PURE__*/React.createElement("rect", {
    x: 394.5,
    y: 280.5,
    width: 6,
    height: 10,
    fill: "#EEEA27",
    stroke: "black"
  })), _rect80 || (_rect80 = /*#__PURE__*/React.createElement("rect", {
    x: 394.5,
    y: 297.5,
    width: 6,
    height: 10,
    fill: "#EEEA27",
    stroke: "black"
  })), _rect81 || (_rect81 = /*#__PURE__*/React.createElement("rect", {
    x: 394.5,
    y: 314.5,
    width: 6,
    height: 10,
    fill: "#EEEA27",
    stroke: "black"
  })), _rect82 || (_rect82 = /*#__PURE__*/React.createElement("rect", {
    x: 394.5,
    y: 331.5,
    width: 6,
    height: 10,
    fill: "#EEEA27",
    stroke: "black"
  })), _rect83 || (_rect83 = /*#__PURE__*/React.createElement("rect", {
    x: 394.5,
    y: 348.5,
    width: 6,
    height: 10,
    fill: "#EEEA27",
    stroke: "black"
  })), _rect84 || (_rect84 = /*#__PURE__*/React.createElement("rect", {
    x: 394.5,
    y: 365.5,
    width: 6,
    height: 10,
    fill: "#EEEA27",
    stroke: "black"
  })), _rect85 || (_rect85 = /*#__PURE__*/React.createElement("rect", {
    x: 394.5,
    y: 382.5,
    width: 6,
    height: 10,
    fill: "#EEEA27",
    stroke: "black"
  })), _rect86 || (_rect86 = /*#__PURE__*/React.createElement("rect", {
    x: 394.5,
    y: 399.5,
    width: 6,
    height: 10,
    fill: "#EEEA27",
    stroke: "black"
  })), _rect87 || (_rect87 = /*#__PURE__*/React.createElement("rect", {
    x: 394.5,
    y: 416.5,
    width: 6,
    height: 10,
    fill: "#EEEA27",
    stroke: "black"
  })), _rect88 || (_rect88 = /*#__PURE__*/React.createElement("rect", {
    x: 394.5,
    y: 433.5,
    width: 6,
    height: 10,
    fill: "#EEEA27",
    stroke: "black"
  })), _rect89 || (_rect89 = /*#__PURE__*/React.createElement("rect", {
    x: 394.5,
    y: 450.5,
    width: 6,
    height: 10,
    fill: "#EEEA27",
    stroke: "black"
  })), _rect90 || (_rect90 = /*#__PURE__*/React.createElement("rect", {
    x: 394.5,
    y: 467.5,
    width: 6,
    height: 10,
    fill: "#EEEA27",
    stroke: "black"
  })), _rect91 || (_rect91 = /*#__PURE__*/React.createElement("rect", {
    x: 381.5,
    y: 467.5,
    width: 6,
    height: 10,
    fill: "#EEEA27",
    stroke: "black"
  })), _rect92 || (_rect92 = /*#__PURE__*/React.createElement("rect", {
    x: 381.5,
    y: 229.5,
    width: 6,
    height: 10,
    fill: "#EEEA27",
    stroke: "black"
  })), _rect93 || (_rect93 = /*#__PURE__*/React.createElement("rect", {
    x: 381.5,
    y: 246.5,
    width: 6,
    height: 10,
    fill: "#EEEA27",
    stroke: "black"
  })), _rect94 || (_rect94 = /*#__PURE__*/React.createElement("rect", {
    x: 381.5,
    y: 263.5,
    width: 6,
    height: 10,
    fill: "#EEEA27",
    stroke: "black"
  })), _rect95 || (_rect95 = /*#__PURE__*/React.createElement("rect", {
    x: 381.5,
    y: 280.5,
    width: 6,
    height: 10,
    fill: "#EEEA27",
    stroke: "black"
  })), _rect96 || (_rect96 = /*#__PURE__*/React.createElement("rect", {
    x: 381.5,
    y: 297.5,
    width: 6,
    height: 10,
    fill: "#EEEA27",
    stroke: "black"
  })), _rect97 || (_rect97 = /*#__PURE__*/React.createElement("rect", {
    x: 381.5,
    y: 314.5,
    width: 6,
    height: 10,
    fill: "#EEEA27",
    stroke: "black"
  })), _rect98 || (_rect98 = /*#__PURE__*/React.createElement("rect", {
    x: 381.5,
    y: 331.5,
    width: 6,
    height: 10,
    fill: "#EEEA27",
    stroke: "black"
  })), _rect99 || (_rect99 = /*#__PURE__*/React.createElement("rect", {
    x: 381.5,
    y: 348.5,
    width: 6,
    height: 10,
    fill: "#EEEA27",
    stroke: "black"
  })), _rect100 || (_rect100 = /*#__PURE__*/React.createElement("rect", {
    x: 381.5,
    y: 365.5,
    width: 6,
    height: 10,
    fill: "#EEEA27",
    stroke: "black"
  })), _rect101 || (_rect101 = /*#__PURE__*/React.createElement("rect", {
    x: 381.5,
    y: 382.5,
    width: 6,
    height: 10,
    fill: "#EEEA27",
    stroke: "black"
  })), _rect102 || (_rect102 = /*#__PURE__*/React.createElement("rect", {
    x: 381.5,
    y: 399.5,
    width: 6,
    height: 10,
    fill: "#EEEA27",
    stroke: "black"
  })), _rect103 || (_rect103 = /*#__PURE__*/React.createElement("rect", {
    x: 381.5,
    y: 416.5,
    width: 6,
    height: 10,
    fill: "#EEEA27",
    stroke: "black"
  })), _rect104 || (_rect104 = /*#__PURE__*/React.createElement("rect", {
    x: 381.5,
    y: 433.5,
    width: 6,
    height: 10,
    fill: "#EEEA27",
    stroke: "black"
  })), _rect105 || (_rect105 = /*#__PURE__*/React.createElement("rect", {
    x: 381.5,
    y: 450.5,
    width: 6,
    height: 10,
    fill: "#EEEA27",
    stroke: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M448 195.5V205.5H442V195.5H448Z",
    fill: "#EEEA27",
    stroke: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M128 493H25V486.987V148.268V140.752L51.9634 136.994V119.707L56.2775 117.202L64.3665 115.699L71.9162 114.697V90.6457L70.2984 89.1425V82.6287L72.4555 81.1255H77.5785H82.7016L84.3194 82.6287V89.1425L82.1623 90.6457V114.697H86.4764L94.0262 115.699L101.576 117.202L104.812 119.707V137.201L128 140.752V486.987V493Z",
    fill: "#2A6375"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M78.9267 133.236L25 486.987M78.9267 133.236L128 486.987M78.9267 133.236L51.9634 136.994M78.9267 133.236L104.812 137.201M25 486.987V493H128V486.987M25 486.987V148.268V140.752L51.9634 136.994M128 486.987V140.752L104.812 137.201M51.9634 136.994V119.707L56.2775 117.202L64.3665 115.699L71.9162 114.697M71.9162 114.697V90.6457M71.9162 114.697H82.1623M104.812 137.201V119.707L101.576 117.202L94.0262 115.699L86.4764 114.697H82.1623M71.9162 90.6457H82.1623M71.9162 90.6457L70.2984 89.1426V82.6287L72.4555 81.1255H77.5785M82.1623 90.6457V114.697M82.1623 90.6457L84.3194 89.1426V82.6287L82.7016 81.1255H77.5785M77.5785 22V81.1255",
    stroke: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M79.5 132L129 492.5H25L79.5 132Z",
    fill: "#547178",
    stroke: "black"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 77,
    y1: 152.5,
    x2: 81,
    y2: 152.5,
    stroke: "#BDFF00"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 76,
    y1: 164.5,
    x2: 83,
    y2: 164.5,
    stroke: "#BDFF00"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 74,
    y1: 176.5,
    x2: 85,
    y2: 176.5,
    stroke: "#BDFF00"
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 73,
    y1: 188.5,
    x2: 85,
    y2: 188.5,
    stroke: "#BDFF00"
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 71,
    y1: 200.5,
    x2: 87,
    y2: 200.5,
    stroke: "#BDFF00"
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 69,
    y1: 212.5,
    x2: 89,
    y2: 212.5,
    stroke: "#BDFF00"
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    x1: 67,
    y1: 224.5,
    x2: 91,
    y2: 224.5,
    stroke: "#BDFF00"
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    x1: 65,
    y1: 236.5,
    x2: 93,
    y2: 236.5,
    stroke: "#BDFF00"
  })), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    x1: 63,
    y1: 248.5,
    x2: 94,
    y2: 248.5,
    stroke: "#BDFF00"
  })), _line0 || (_line0 = /*#__PURE__*/React.createElement("line", {
    x1: 61,
    y1: 260.5,
    x2: 96,
    y2: 260.5,
    stroke: "#BDFF00"
  })), _line1 || (_line1 = /*#__PURE__*/React.createElement("line", {
    x1: 59,
    y1: 272.5,
    x2: 98,
    y2: 272.5,
    stroke: "#BDFF00"
  })), _line10 || (_line10 = /*#__PURE__*/React.createElement("line", {
    x1: 58,
    y1: 284.5,
    x2: 99,
    y2: 284.5,
    stroke: "#BDFF00"
  })), _line11 || (_line11 = /*#__PURE__*/React.createElement("line", {
    x1: 56,
    y1: 296.5,
    x2: 101,
    y2: 296.5,
    stroke: "#BDFF00"
  })), _line12 || (_line12 = /*#__PURE__*/React.createElement("line", {
    x1: 54,
    y1: 308.5,
    x2: 102,
    y2: 308.5,
    stroke: "#BDFF00"
  })), _line13 || (_line13 = /*#__PURE__*/React.createElement("line", {
    x1: 52,
    y1: 320.5,
    x2: 104,
    y2: 320.5,
    stroke: "#BDFF00"
  })), _line14 || (_line14 = /*#__PURE__*/React.createElement("line", {
    x1: 50,
    y1: 332.5,
    x2: 106,
    y2: 332.5,
    stroke: "#BDFF00"
  })), _line15 || (_line15 = /*#__PURE__*/React.createElement("line", {
    x1: 48,
    y1: 344.5,
    x2: 108,
    y2: 344.5,
    stroke: "#BDFF00"
  })), _line16 || (_line16 = /*#__PURE__*/React.createElement("line", {
    x1: 47,
    y1: 356.5,
    x2: 109,
    y2: 356.5,
    stroke: "#BDFF00"
  })), _line17 || (_line17 = /*#__PURE__*/React.createElement("line", {
    x1: 45,
    y1: 368.5,
    x2: 110,
    y2: 368.5,
    stroke: "#BDFF00"
  })), _line18 || (_line18 = /*#__PURE__*/React.createElement("line", {
    x1: 43,
    y1: 380.5,
    x2: 113,
    y2: 380.5,
    stroke: "#BDFF00"
  })), _line19 || (_line19 = /*#__PURE__*/React.createElement("line", {
    x1: 41,
    y1: 392.5,
    x2: 114,
    y2: 392.5,
    stroke: "#BDFF00"
  })), _line20 || (_line20 = /*#__PURE__*/React.createElement("line", {
    x1: 39,
    y1: 404.5,
    x2: 116,
    y2: 404.5,
    stroke: "#BDFF00"
  })), _line21 || (_line21 = /*#__PURE__*/React.createElement("line", {
    x1: 37,
    y1: 416.5,
    x2: 117,
    y2: 416.5,
    stroke: "#BDFF00"
  })), _line22 || (_line22 = /*#__PURE__*/React.createElement("line", {
    x1: 36,
    y1: 428.5,
    x2: 119,
    y2: 428.5,
    stroke: "#BDFF00"
  })), _line23 || (_line23 = /*#__PURE__*/React.createElement("line", {
    x1: 34,
    y1: 440.5,
    x2: 121,
    y2: 440.5,
    stroke: "#BDFF00"
  })), _line24 || (_line24 = /*#__PURE__*/React.createElement("line", {
    x1: 32,
    y1: 452.5,
    x2: 122,
    y2: 452.5,
    stroke: "#BDFF00"
  })), _line25 || (_line25 = /*#__PURE__*/React.createElement("line", {
    x1: 30,
    y1: 464.5,
    x2: 124,
    y2: 464.5,
    stroke: "#BDFF00"
  })), _line26 || (_line26 = /*#__PURE__*/React.createElement("line", {
    x1: 29,
    y1: 476.5,
    x2: 126,
    y2: 476.5,
    stroke: "#BDFF00"
  })), _line27 || (_line27 = /*#__PURE__*/React.createElement("line", {
    x1: 27,
    y1: 488.5,
    x2: 127,
    y2: 488.5,
    stroke: "#BDFF00"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_206_2)"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 77,
    y1: 81,
    x2: 77,
    y2: 22,
    stroke: "#052DB3",
    strokeWidth: 4,
    className: "antenna-light"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M539.905 346.5H527.389V490.5H578L574.449 334V156H539.905V346.5Z",
    fill: "#5F6465",
    stroke: "black"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M246.538 313.384H225V492H380.199V255.031H342.825V264.282H338.391V334.021H328.255V341.849H303.55V195.255H295.948V174.618H285.179V149H272.51V174.618H261.741V195.255H254.773V341.849H246.538V313.384Z",
    fill: "#5F6465",
    stroke: "black"
  })), _rect106 || (_rect106 = /*#__PURE__*/React.createElement("rect", {
    x: 262.548,
    y: 206.5,
    width: 6.00901,
    height: 10,
    fill: "#EEEA27",
    stroke: "black"
  })), _rect107 || (_rect107 = /*#__PURE__*/React.createElement("rect", {
    x: 289.583,
    y: 237.5,
    width: 6.00901,
    height: 10,
    fill: "#EEEA27",
    stroke: "black"
  })), _rect108 || (_rect108 = /*#__PURE__*/React.createElement("rect", {
    x: 262.548,
    y: 285.5,
    width: 6.00901,
    height: 10,
    fill: "#EEEA27",
    stroke: "black"
  })), _rect109 || (_rect109 = /*#__PURE__*/React.createElement("rect", {
    x: 289.583,
    y: 333.5,
    width: 6.00901,
    height: 10,
    fill: "#EEEA27",
    stroke: "black"
  })), _rect110 || (_rect110 = /*#__PURE__*/React.createElement("rect", {
    x: 348.658,
    y: 302.5,
    width: 6.00901,
    height: 10,
    fill: "#EEEA27",
    stroke: "black"
  })), _rect111 || (_rect111 = /*#__PURE__*/React.createElement("rect", {
    x: 230.506,
    y: 393.5,
    width: 6.00901,
    height: 10,
    fill: "#EEEA27",
    stroke: "black"
  })), _rect112 || (_rect112 = /*#__PURE__*/React.createElement("rect", {
    x: 285.577,
    y: 470.5,
    width: 6.00901,
    height: 10,
    fill: "#EEEA27",
    stroke: "black"
  })), _rect113 || (_rect113 = /*#__PURE__*/React.createElement("rect", {
    x: 259.544,
    y: 426.5,
    width: 6.00901,
    height: 10,
    fill: "#EEEA27",
    stroke: "black"
  })), _rect114 || (_rect114 = /*#__PURE__*/React.createElement("rect", {
    x: 269.557,
    y: 367.5,
    width: 6.00901,
    height: 10,
    fill: "#EEEA27",
    stroke: "black"
  })), _rect115 || (_rect115 = /*#__PURE__*/React.createElement("rect", {
    x: 495.848,
    y: 405.5,
    width: 6.00901,
    height: 10,
    fill: "#EEEA27",
    stroke: "black"
  })), _rect116 || (_rect116 = /*#__PURE__*/React.createElement("rect", {
    x: 474.82,
    y: 362.5,
    width: 6.00901,
    height: 10,
    fill: "#EEEA27",
    stroke: "black"
  })), _rect117 || (_rect117 = /*#__PURE__*/React.createElement("rect", {
    x: 505.86,
    y: 317.5,
    width: 6.00901,
    height: 10,
    fill: "#EEEA27",
    stroke: "black"
  })), _rect118 || (_rect118 = /*#__PURE__*/React.createElement("rect", {
    x: 488.838,
    y: 287.5,
    width: 6.00901,
    height: 10,
    fill: "#EEEA27",
    stroke: "black"
  })), _rect119 || (_rect119 = /*#__PURE__*/React.createElement("rect", {
    x: 563.935,
    y: 217.5,
    width: 6.00901,
    height: 10,
    fill: "#EEEA27",
    stroke: "black"
  })), _rect120 || (_rect120 = /*#__PURE__*/React.createElement("rect", {
    x: 545.912,
    y: 173.5,
    width: 6.00901,
    height: 10,
    fill: "#EEEA27",
    stroke: "black"
  })), _rect121 || (_rect121 = /*#__PURE__*/React.createElement("rect", {
    x: 365.68,
    y: 268.5,
    width: 6.00901,
    height: 10,
    fill: "#EEEA27",
    stroke: "black"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M375.5 364V493H306V364H302V353H380V364H375.5Z",
    fill: "#790808"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M375.5 364V493H306V364M375.5 364H306M375.5 364H380V353H302V364H306",
    stroke: "black"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M380 364V353H302V364H380Z",
    fill: "#3C3D3F",
    stroke: "black"
  })), _rect122 || (_rect122 = /*#__PURE__*/React.createElement("rect", {
    x: 311,
    y: 443,
    width: 9,
    height: 14,
    fill: "#FFF31E",
    stroke: "black"
  })), _rect123 || (_rect123 = /*#__PURE__*/React.createElement("rect", {
    x: 311,
    y: 466,
    width: 9,
    height: 14,
    fill: "#FFF31E",
    stroke: "black"
  })), _rect124 || (_rect124 = /*#__PURE__*/React.createElement("rect", {
    x: 327,
    y: 466,
    width: 9,
    height: 14,
    fill: "#FFF31E",
    stroke: "black"
  })), _rect125 || (_rect125 = /*#__PURE__*/React.createElement("rect", {
    x: 343,
    y: 466,
    width: 9,
    height: 14,
    fill: "#FFF31E",
    stroke: "black"
  })), _rect126 || (_rect126 = /*#__PURE__*/React.createElement("rect", {
    x: 359,
    y: 466,
    width: 9,
    height: 14,
    fill: "#FFF31E",
    stroke: "black"
  })), _rect127 || (_rect127 = /*#__PURE__*/React.createElement("rect", {
    x: 327,
    y: 443,
    width: 9,
    height: 14,
    fill: "#FFF31E",
    stroke: "black"
  })), _rect128 || (_rect128 = /*#__PURE__*/React.createElement("rect", {
    x: 343,
    y: 443,
    width: 9,
    height: 14,
    fill: "#FFF31E",
    stroke: "black"
  })), _rect129 || (_rect129 = /*#__PURE__*/React.createElement("rect", {
    x: 359,
    y: 443,
    width: 9,
    height: 14,
    fill: "#FFF31E",
    stroke: "black"
  })), _rect130 || (_rect130 = /*#__PURE__*/React.createElement("rect", {
    x: 359,
    y: 420,
    width: 9,
    height: 14,
    fill: "#FFF31E",
    stroke: "black"
  })), _rect131 || (_rect131 = /*#__PURE__*/React.createElement("rect", {
    x: 343,
    y: 420,
    width: 9,
    height: 14,
    fill: "#FFF31E",
    stroke: "black"
  })), _rect132 || (_rect132 = /*#__PURE__*/React.createElement("rect", {
    x: 327,
    y: 420,
    width: 9,
    height: 14,
    fill: "#FFF31E",
    stroke: "black"
  })), _rect133 || (_rect133 = /*#__PURE__*/React.createElement("rect", {
    x: 311,
    y: 420,
    width: 9,
    height: 14,
    fill: "#FFF31E",
    stroke: "black"
  })), _rect134 || (_rect134 = /*#__PURE__*/React.createElement("rect", {
    x: 311,
    y: 397,
    width: 9,
    height: 14,
    fill: "#FFF31E",
    stroke: "black"
  })), _rect135 || (_rect135 = /*#__PURE__*/React.createElement("rect", {
    x: 327,
    y: 397,
    width: 9,
    height: 14,
    fill: "#FFF31E",
    stroke: "black"
  })), _rect136 || (_rect136 = /*#__PURE__*/React.createElement("rect", {
    x: 343,
    y: 397,
    width: 9,
    height: 14,
    fill: "#FFF31E",
    stroke: "black"
  })), _rect137 || (_rect137 = /*#__PURE__*/React.createElement("rect", {
    x: 359,
    y: 397,
    width: 9,
    height: 14,
    fill: "#FFF31E",
    stroke: "black"
  })), _rect138 || (_rect138 = /*#__PURE__*/React.createElement("rect", {
    x: 359,
    y: 374,
    width: 9,
    height: 14,
    fill: "#FFF31E",
    stroke: "black"
  })), _rect139 || (_rect139 = /*#__PURE__*/React.createElement("rect", {
    x: 343,
    y: 373,
    width: 9,
    height: 14,
    fill: "#FFF31E",
    stroke: "black"
  })), _rect140 || (_rect140 = /*#__PURE__*/React.createElement("rect", {
    x: 327,
    y: 373,
    width: 9,
    height: 14,
    fill: "#FFF31E",
    stroke: "black"
  })), _rect141 || (_rect141 = /*#__PURE__*/React.createElement("rect", {
    x: 311,
    y: 373,
    width: 9,
    height: 14,
    fill: "#FFF31E",
    stroke: "black"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M224.5 291.5H129V298.5H224.5V291.5Z",
    stroke: "black"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M224.5 298.5H129V305.5H224.5V298.5Z",
    stroke: "black"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M224.5 305.5H129V312.5H224.5V305.5Z",
    stroke: "black"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M224.5 284.5H129V291.5H224.5V284.5Z",
    stroke: "black"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M224.5 280H129V296.5V492H224.5V280Z",
    fill: "#3C3D3F",
    stroke: "black"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M224.5 431.5H129V438.5H224.5V431.5Z",
    stroke: "black"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M224.5 368.5H129V375.5H224.5V368.5Z",
    stroke: "black"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M224.5 305.5H129V312.5H224.5V305.5Z",
    fill: "#FFF31E",
    stroke: "black"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M224.5 312.5H129V319.5H224.5V312.5Z",
    stroke: "black"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M224.5 319.5H129V326.5H224.5V319.5Z",
    fill: "#FFF31E",
    stroke: "black"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M224.5 326.5H129V333.5H224.5V326.5Z",
    stroke: "black"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M224.5 333.5H129V340.5H224.5V333.5Z",
    fill: "#FFF31E",
    stroke: "black"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M224.5 340.5H129V347.5H224.5V340.5Z",
    stroke: "black"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M224.5 347.5H129V354.5H224.5V347.5Z",
    fill: "#FFF31E",
    stroke: "black"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M224.5 354.5H129V361.5H224.5V354.5Z",
    stroke: "black"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M224.5 361.5H129V368.5H224.5V361.5Z",
    fill: "#FFF31E",
    stroke: "black"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M224.5 431.5H129V438.5H224.5V431.5Z",
    fill: "#FFF31E",
    stroke: "black"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M224.5 445.5H129V452.5H224.5V445.5Z",
    fill: "#FFF31E",
    stroke: "black"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M224.5 452.5H129V459.5H224.5V452.5Z",
    stroke: "black"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M224.5 459.5H129V466.5H224.5V459.5Z",
    fill: "#FFF31E",
    stroke: "black"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M224.5 466.5H129V473.5H224.5V466.5Z",
    stroke: "black"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M224.5 473.5H129V480.5H224.5V473.5Z",
    fill: "#FFF31E",
    stroke: "black"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M224.5 375.5H129V382.5H224.5V375.5Z",
    fill: "#FFF31E",
    stroke: "black"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M224.5 382.5H129V389.5H224.5V382.5Z",
    stroke: "black"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M224.5 389.5H129V396.5H224.5V389.5Z",
    fill: "#FFF31E",
    stroke: "black"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M224.5 396.5H129V403.5H224.5V396.5Z",
    stroke: "black"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M224.5 403.5H129V410.5H224.5V403.5Z",
    fill: "#FFF31E",
    stroke: "black"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M224.5 410.5H129V417.5H224.5V410.5Z",
    stroke: "black"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M224.5 417.5H129V424.5H224.5V417.5Z",
    fill: "#FFF31E",
    stroke: "black"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M224.5 424.5H129V431.5H224.5V424.5Z",
    stroke: "black"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M224.5 424.5H129V431.5H224.5V424.5Z",
    stroke: "black"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M305 423.5V492L298 491.956L284 491.867L278.5 491.832L253.5 491.674L248.5 491.642L226 491.5L226.5 422H229L228.5 402H231V382.5L240.5 322V313H243V322L251.676 382.5L251.5 402.5H254L253.5 422L265.5 403.5V396.5H263.5V395.5H265.5V393H267.5V395.5H269.5V396.5H267.5V403.5L278.5 421V402H281.5V382.5L290 322V313H292V322L301 384V402H303V423.5H305Z",
    fill: "#8C7F5F"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M248.5 491.642L226 491.5L226.5 422H229L228.5 402H231V382.5L240.5 322V313H243V322L251.676 382.5L251.5 402.5H254L253.5 422L265.5 403.5V396.5H263.5V395.5H265.5V393H267.5V395.5H269.5V396.5H267.5V403.5L278.5 421V402H281.5V382.5L290 322V313H292V322L301 384V402H303V423.5H305V492L298 491.956L284 491.867L278.5 491.832L253.5 491.674L248.5 491.642ZM248.5 491.642L234 491.5",
    stroke: "black"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M258 473.5V491.5H275V473.5L266.5 463L258 473.5Z",
    fill: "#FFF31E",
    stroke: "black"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M239.478 397.5H237C236.448 397.5 236 397.052 236 396.5V374.236C236 374.081 236.036 373.927 236.106 373.788L237.106 371.789C237.474 371.052 238.526 371.052 238.894 371.789L239.899 373.799C239.966 373.931 240.002 374.077 240.005 374.225L240.478 396.479C240.49 397.039 240.039 397.5 239.478 397.5Z",
    fill: "#FFF31E",
    stroke: "black"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M245.978 397.5H243.5C242.948 397.5 242.5 397.052 242.5 396.5V374.236C242.5 374.081 242.536 373.927 242.606 373.788L243.606 371.789C243.974 371.052 245.026 371.052 245.394 371.789L246.399 373.799C246.466 373.931 246.502 374.077 246.505 374.225L246.978 396.479C246.99 397.039 246.539 397.5 245.978 397.5Z",
    fill: "#FFF31E",
    stroke: "black"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M288.978 397.5H286.5C285.948 397.5 285.5 397.052 285.5 396.5V374.236C285.5 374.081 285.536 373.927 285.606 373.788L286.606 371.789C286.974 371.052 288.026 371.052 288.394 371.789L289.399 373.799C289.466 373.931 289.502 374.077 289.505 374.225L289.978 396.479C289.99 397.039 289.539 397.5 288.978 397.5Z",
    fill: "#FFF31E",
    stroke: "black"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M295.978 397.5H293.5C292.948 397.5 292.5 397.052 292.5 396.5V374.236C292.5 374.081 292.536 373.927 292.606 373.788L293.606 371.789C293.974 371.052 295.026 371.052 295.394 371.789L296.399 373.799C296.466 373.931 296.502 374.077 296.505 374.225L296.978 396.479C296.99 397.039 296.539 397.5 295.978 397.5Z",
    fill: "#FFF31E",
    stroke: "black"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M238 478.5V491.5H245V478.5L241.5 472L238 478.5Z",
    fill: "#FFF31E",
    stroke: "black"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M287.5 478.5V491.5H294.5V478.5L291 472L287.5 478.5Z",
    fill: "#FFF31E",
    stroke: "black"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M295 450H287L287.5 435.5L291 430.5L294.5 435.5L295 450Z",
    fill: "#FFF31E",
    stroke: "black"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M244.5 449.5H236.5L237 435L240.5 430L244 435L244.5 449.5Z",
    fill: "#FFF31E",
    stroke: "black"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 266.5,
    cy: 434,
    r: 8.5,
    fill: "#FFF31E",
    stroke: "black"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M266.5 393V402.947V403.5",
    stroke: "black"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M585 308.415V432.647V493H526V230H543.911V254.67H558.134V278.459H572.884V308.415H585Z",
    fill: "#6C5F75",
    stroke: "black"
  })), _rect142 || (_rect142 = /*#__PURE__*/React.createElement("rect", {
    x: 573.5,
    y: 323.5,
    width: 6,
    height: 10,
    fill: "#EEEA27",
    stroke: "black"
  })), _rect143 || (_rect143 = /*#__PURE__*/React.createElement("rect", {
    x: 573.5,
    y: 342.5,
    width: 6,
    height: 10,
    fill: "#EEEA27",
    stroke: "black"
  })), _rect144 || (_rect144 = /*#__PURE__*/React.createElement("rect", {
    x: 573.5,
    y: 360.5,
    width: 6,
    height: 10,
    fill: "#EEEA27",
    stroke: "black"
  })), _rect145 || (_rect145 = /*#__PURE__*/React.createElement("rect", {
    x: 573.5,
    y: 398.5,
    width: 6,
    height: 10,
    fill: "#EEEA27",
    stroke: "black"
  })), _rect146 || (_rect146 = /*#__PURE__*/React.createElement("rect", {
    x: 573.5,
    y: 436.5,
    width: 6,
    height: 10,
    fill: "#EEEA27",
    stroke: "black"
  })), _rect147 || (_rect147 = /*#__PURE__*/React.createElement("rect", {
    x: 573.5,
    y: 455.5,
    width: 6,
    height: 10,
    fill: "#010101",
    stroke: "black"
  })), _rect148 || (_rect148 = /*#__PURE__*/React.createElement("rect", {
    x: 573.5,
    y: 379.5,
    width: 6,
    height: 10,
    fill: "#EEEA27",
    stroke: "black"
  })), _rect149 || (_rect149 = /*#__PURE__*/React.createElement("rect", {
    x: 573.5,
    y: 417.5,
    width: 6,
    height: 10,
    fill: "#EEEA27",
    stroke: "black"
  })), _rect150 || (_rect150 = /*#__PURE__*/React.createElement("rect", {
    x: 573.5,
    y: 455.5,
    width: 6,
    height: 10,
    fill: "#EEEA27",
    stroke: "black"
  })), _rect151 || (_rect151 = /*#__PURE__*/React.createElement("rect", {
    x: 573.5,
    y: 474.5,
    width: 6,
    height: 10,
    fill: "#EEEA27",
    stroke: "black"
  })), _rect152 || (_rect152 = /*#__PURE__*/React.createElement("rect", {
    x: 532.5,
    y: 285.5,
    width: 6,
    height: 10,
    fill: "#EEEA27",
    stroke: "black"
  })), _rect153 || (_rect153 = /*#__PURE__*/React.createElement("rect", {
    x: 532.5,
    y: 304.5,
    width: 6,
    height: 10,
    fill: "#EEEA27",
    stroke: "black"
  })), _rect154 || (_rect154 = /*#__PURE__*/React.createElement("rect", {
    x: 532.5,
    y: 323.5,
    width: 6,
    height: 10,
    fill: "#EEEA27",
    stroke: "black"
  })), _rect155 || (_rect155 = /*#__PURE__*/React.createElement("rect", {
    x: 532.5,
    y: 342.5,
    width: 6,
    height: 10,
    fill: "#EEEA27",
    stroke: "black"
  })), _rect156 || (_rect156 = /*#__PURE__*/React.createElement("rect", {
    x: 532.5,
    y: 360.5,
    width: 6,
    height: 10,
    fill: "#EEEA27",
    stroke: "black"
  })), _rect157 || (_rect157 = /*#__PURE__*/React.createElement("rect", {
    x: 532.5,
    y: 379.5,
    width: 6,
    height: 10,
    fill: "#EEEA27",
    stroke: "black"
  })), _rect158 || (_rect158 = /*#__PURE__*/React.createElement("rect", {
    x: 532.5,
    y: 398.5,
    width: 6,
    height: 10,
    fill: "#EEEA27",
    stroke: "black"
  })), _rect159 || (_rect159 = /*#__PURE__*/React.createElement("rect", {
    x: 532.5,
    y: 436.5,
    width: 6,
    height: 10,
    fill: "#EEEA27",
    stroke: "black"
  })), _rect160 || (_rect160 = /*#__PURE__*/React.createElement("rect", {
    x: 532.5,
    y: 455.5,
    width: 6,
    height: 10,
    fill: "#010101",
    stroke: "black"
  })), _rect161 || (_rect161 = /*#__PURE__*/React.createElement("rect", {
    x: 532.5,
    y: 417.5,
    width: 6,
    height: 10,
    fill: "#EEEA27",
    stroke: "black"
  })), _rect162 || (_rect162 = /*#__PURE__*/React.createElement("rect", {
    x: 532.5,
    y: 455.5,
    width: 6,
    height: 10,
    fill: "#EEEA27",
    stroke: "black"
  })), _rect163 || (_rect163 = /*#__PURE__*/React.createElement("rect", {
    x: 532.5,
    y: 474.5,
    width: 6,
    height: 10,
    fill: "#EEEA27",
    stroke: "black"
  })), _rect164 || (_rect164 = /*#__PURE__*/React.createElement("rect", {
    x: 546.5,
    y: 265.5,
    width: 6,
    height: 10,
    fill: "#EEEA27",
    stroke: "black"
  })), _rect165 || (_rect165 = /*#__PURE__*/React.createElement("rect", {
    x: 532.5,
    y: 265.5,
    width: 6,
    height: 10,
    fill: "#EEEA27",
    stroke: "black"
  })), _rect166 || (_rect166 = /*#__PURE__*/React.createElement("rect", {
    x: 546.5,
    y: 285.5,
    width: 6,
    height: 10,
    fill: "#EEEA27",
    stroke: "black"
  })), _rect167 || (_rect167 = /*#__PURE__*/React.createElement("rect", {
    x: 546.5,
    y: 304.5,
    width: 6,
    height: 10,
    fill: "#EEEA27",
    stroke: "black"
  })), _rect168 || (_rect168 = /*#__PURE__*/React.createElement("rect", {
    x: 546.5,
    y: 323.5,
    width: 6,
    height: 10,
    fill: "#EEEA27",
    stroke: "black"
  })), _rect169 || (_rect169 = /*#__PURE__*/React.createElement("rect", {
    x: 546.5,
    y: 342.5,
    width: 6,
    height: 10,
    fill: "#EEEA27",
    stroke: "black"
  })), _rect170 || (_rect170 = /*#__PURE__*/React.createElement("rect", {
    x: 546.5,
    y: 360.5,
    width: 6,
    height: 10,
    fill: "#EEEA27",
    stroke: "black"
  })), _rect171 || (_rect171 = /*#__PURE__*/React.createElement("rect", {
    x: 546.5,
    y: 398.5,
    width: 6,
    height: 10,
    fill: "#EEEA27",
    stroke: "black"
  })), _rect172 || (_rect172 = /*#__PURE__*/React.createElement("rect", {
    x: 546.5,
    y: 436.5,
    width: 6,
    height: 10,
    fill: "#EEEA27",
    stroke: "black"
  })), _rect173 || (_rect173 = /*#__PURE__*/React.createElement("rect", {
    x: 546.5,
    y: 455.5,
    width: 6,
    height: 10,
    fill: "#010101",
    stroke: "black"
  })), _rect174 || (_rect174 = /*#__PURE__*/React.createElement("rect", {
    x: 546.5,
    y: 379.5,
    width: 6,
    height: 10,
    fill: "#EEEA27",
    stroke: "black"
  })), _rect175 || (_rect175 = /*#__PURE__*/React.createElement("rect", {
    x: 546.5,
    y: 417.5,
    width: 6,
    height: 10,
    fill: "#EEEA27",
    stroke: "black"
  })), _rect176 || (_rect176 = /*#__PURE__*/React.createElement("rect", {
    x: 546.5,
    y: 455.5,
    width: 6,
    height: 10,
    fill: "#EEEA27",
    stroke: "black"
  })), _rect177 || (_rect177 = /*#__PURE__*/React.createElement("rect", {
    x: 546.5,
    y: 474.5,
    width: 6,
    height: 10,
    fill: "#EEEA27",
    stroke: "black"
  })), _rect178 || (_rect178 = /*#__PURE__*/React.createElement("rect", {
    x: 560.5,
    y: 285.5,
    width: 6,
    height: 10,
    fill: "#EEEA27",
    stroke: "black"
  })), _rect179 || (_rect179 = /*#__PURE__*/React.createElement("rect", {
    x: 560.5,
    y: 304.5,
    width: 6,
    height: 10,
    fill: "#EEEA27",
    stroke: "black"
  })), _rect180 || (_rect180 = /*#__PURE__*/React.createElement("rect", {
    x: 560.5,
    y: 323.5,
    width: 6,
    height: 10,
    fill: "#EEEA27",
    stroke: "black"
  })), _rect181 || (_rect181 = /*#__PURE__*/React.createElement("rect", {
    x: 560.5,
    y: 342.5,
    width: 6,
    height: 10,
    fill: "#EEEA27",
    stroke: "black"
  })), _rect182 || (_rect182 = /*#__PURE__*/React.createElement("rect", {
    x: 560.5,
    y: 360.5,
    width: 6,
    height: 10,
    fill: "#EEEA27",
    stroke: "black"
  })), _rect183 || (_rect183 = /*#__PURE__*/React.createElement("rect", {
    x: 560.5,
    y: 398.5,
    width: 6,
    height: 10,
    fill: "#EEEA27",
    stroke: "black"
  })), _rect184 || (_rect184 = /*#__PURE__*/React.createElement("rect", {
    x: 560.5,
    y: 436.5,
    width: 6,
    height: 10,
    fill: "#EEEA27",
    stroke: "black"
  })), _rect185 || (_rect185 = /*#__PURE__*/React.createElement("rect", {
    x: 560.5,
    y: 455.5,
    width: 6,
    height: 10,
    fill: "#010101",
    stroke: "black"
  })), _rect186 || (_rect186 = /*#__PURE__*/React.createElement("rect", {
    x: 560.5,
    y: 379.5,
    width: 6,
    height: 10,
    fill: "#EEEA27",
    stroke: "black"
  })), _rect187 || (_rect187 = /*#__PURE__*/React.createElement("rect", {
    x: 560.5,
    y: 417.5,
    width: 6,
    height: 10,
    fill: "#EEEA27",
    stroke: "black"
  })), _rect188 || (_rect188 = /*#__PURE__*/React.createElement("rect", {
    x: 560.5,
    y: 455.5,
    width: 6,
    height: 10,
    fill: "#EEEA27",
    stroke: "black"
  })), _rect189 || (_rect189 = /*#__PURE__*/React.createElement("rect", {
    x: 560.5,
    y: 474.5,
    width: 6,
    height: 10,
    fill: "#EEEA27",
    stroke: "black"
  })), _rect190 || (_rect190 = /*#__PURE__*/React.createElement("rect", {
    x: 532.5,
    y: 239.5,
    width: 6,
    height: 10,
    fill: "#EEEA27",
    stroke: "black"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M520 186L466 234V493.5H526V186H520Z",
    fill: "#4A5E6C",
    stroke: "black"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M526 248H466V254H526V248Z",
    stroke: "black"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M466 248V243H526V248H466Z",
    fill: "#FFF31E",
    stroke: "black"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M526 254H466V260H526V254Z",
    fill: "#FFF31E",
    stroke: "black"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M526 272H466V278H526V272Z",
    stroke: "black"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M526 278H466V284H526V278Z",
    fill: "#FFF31E",
    stroke: "black"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M526 284H466V290H526V284Z",
    stroke: "black"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M526 290H466V296H526V290Z",
    fill: "#FFF31E",
    stroke: "black"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M526 302H466V308H526V302Z",
    stroke: "black"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M526 308H466V314H526V308Z",
    stroke: "black"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M526 314H466V320H526V314Z",
    fill: "#FFF31E",
    stroke: "black"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M466 296H526M466 296C489.431 296 502.569 296 526 296V302H466V296Z",
    stroke: "black"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M526 302H466V308H526V302Z",
    fill: "#FFF31E"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M466 302H526M466 302C489.431 302 502.569 302 526 302V308H466V302Z",
    stroke: "black"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M526 320H466V326H526V320Z",
    stroke: "black"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M526 326H466V332H526V326Z",
    fill: "#FFF31E",
    stroke: "black"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M526 332H466V338H526V332Z",
    stroke: "black"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M526 338H466V344H526V338Z",
    fill: "#FFF31E",
    stroke: "black"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M526 344H466V350H526V344Z",
    stroke: "black"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M526 350H466V356H526V350Z",
    fill: "#FFF31E",
    stroke: "black"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M526 356H466V362H526V356Z",
    stroke: "black"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M526 362H466V368H526V362Z",
    fill: "#FFF31E",
    stroke: "black"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M526 368H466V374H526V368Z",
    stroke: "black"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M526 260H466V266H526V260Z",
    stroke: "black"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M526 266H466V272H526V266Z",
    fill: "#FFF31E",
    stroke: "black"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M526 374H466V380H526V374Z",
    fill: "#FFF31E",
    stroke: "black"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M526 380H466V386H526V380Z",
    stroke: "black"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M526 398H466V404H526V398Z",
    fill: "#FFF31E",
    stroke: "black"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M526 386H466V392H526V386Z",
    fill: "#FFF31E",
    stroke: "black"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M526 410H466V416H526V410Z",
    fill: "#FFF31E",
    stroke: "black"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M526 416H466V422H526V416Z",
    stroke: "black"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M526 422H466V428H526V422Z",
    fill: "#FFF31E",
    stroke: "black"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M526 428H466V434H526V428Z",
    stroke: "black"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M526 434H466V440H526V434Z",
    fill: "#FFF31E",
    stroke: "black"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M526 440H466V446H526V440Z",
    stroke: "black"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M526 446H466V452H526V446Z",
    fill: "#FFF31E",
    stroke: "black"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M526 452H466V458H526V452Z",
    stroke: "black"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M526 458H466V464H526V458Z",
    stroke: "black"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M526 458H466V464H526V458Z",
    fill: "#FFF31E",
    stroke: "black"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M526 464H466V470H526V464Z",
    stroke: "black"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M526 470H466V476H526V470Z",
    fill: "#FFF31E",
    stroke: "black"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M526 476H466V482H526V476Z",
    stroke: "black"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M526 482H466V488H526V482Z",
    fill: "#FFF31E",
    stroke: "black"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_206_2",
    x: 53,
    y: 0,
    width: 48,
    height: 103,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 11
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_206_2"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_206_2",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNightBuildings);
export default __webpack_public_path__ + "static/media/night-buildings.24b0949afc85574e37193abc858cbdd4.svg";
export { ForwardRef as ReactComponent };